<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div
    *ngIf="contragent"
    class="grid mb-5">
    <div class="xl:col-6 lg:col-6 col-12">
      <p-card header="Контрагент">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Тип контрагента</label>
            <crm-single-select
              [options]="jurisdictions"
              [(selectedItem)]="contragent.jurisdiction"
              [filter]="false"
              [isTemplateCombined]="true"
              dataKey="name"
              [class]="errors?.jurisdiction ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.jurisdiction ? 'ng-invalid ng-dirty' : ''">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | jurisdictionType }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.jurisdiction"
              class="p-error">
              {{ errors.jurisdiction | join }}
            </small>
          </div>

          <div
            *ngIf="contragent.jurisdiction !== JurisdictionTypeEnum.FOREIGN"
            class="field">
            <label class="font-medium required-field">ИНН</label>
            <crm-inn-auto-complete
              [isError]="$any(errors?.inn)"
              [(selectedPerson)]="person"
              (selectedPersonChange)="selectedPerson($event)"
              [persons]="persons"
              (personSearch)="searchParson($event)"></crm-inn-auto-complete>
            <small
              *ngIf="errors?.inn"
              class="p-error">
              {{ errors.inn | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Название компании</label>
            <crm-input-text
              [(value)]="contragent.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="contragent.client"
              [isError]="$any(errors?.client)"
              [customSearch]="false"
              [showClear]="true"></crm-client-auto-complete>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Вид деятельности</label>
            <crm-activity-single-select
              [(selectedActivity)]="contragent.activity"
              [isError]="$any(errors?.activity)"
              [showClear]="true"
              appendTo="body"></crm-activity-single-select>
            <small
              *ngIf="errors?.activity"
              class="p-error">
              {{ errors.activity | join }}
            </small>
          </div>

          <div class="formgrid grid">
            <div class="field col">
              <label class="font-medium required-field">Тип</label>
              <crm-single-select
                dataKey="name"
                [options]="personTypes"
                [isTemplateCombined]="true"
                [filter]="false"
                [(selectedItem)]="contragent.personType"
                [styleClass]="errors?.personType ? 'ng-invalid ng-dirty' : ''"
                [class]="errors?.personType ? 'ng-invalid ng-dirty' : ''">
                <ng-template
                  #itemTemplate
                  let-type="item"
                  >{{ type.value | personTypeName }}</ng-template
                >
              </crm-single-select>
              <small
                *ngIf="errors?.personType"
                class="p-error">
                {{ errors.personType | join }}
              </small>
            </div>

            <div class="field col">
              <label class="font-medium">Генеральный директор</label>
              <crm-input-text
                [(value)]="contragent.manager"
                [isError]="$any(errors?.manager)"></crm-input-text>
              <small
                *ngIf="errors?.manager"
                class="p-error">
                {{ errors.manager | join }}
              </small>
            </div>
          </div>

          <div class="formgrid grid">
            <div class="field col">
              <label class="font-medium">Email</label>
              <crm-input-text
                [(value)]="contragent.email"
                [isError]="$any(errors?.email)"></crm-input-text>
              <small
                *ngIf="errors?.email"
                class="p-error">
                {{ errors.email | join }}
              </small>
            </div>

            <div class="field col">
              <label class="font-medium">Телефон</label>
              <p-inputMask
                type="text"
                mask="+9 (999) 999-99-99"
                placeholder="+7 (999) 999-99-99"
                [unmask]="true"
                [(ngModel)]="contragent.phone"
                name="phone"></p-inputMask>
              <small
                *ngIf="errors?.phone"
                class="p-error">
                {{ errors.phone | join }}
              </small>
            </div>
          </div>

          <div class="field">
            <label class="font-medium">Сайт</label>
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">https://</span>
              <crm-input-text
                [(value)]="contragent.website"
                class="w-full"
                [isError]="$any(errors?.website)"></crm-input-text>
            </div>
            <small
              *ngIf="errors?.website"
              class="p-error">
              {{ errors.website | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Юридический адрес</label>
            <crm-input-text
              [(value)]="contragent.address"
              [isError]="$any(errors?.address)"></crm-input-text>
            <small
              *ngIf="errors?.address"
              class="p-error">
              {{ errors.address | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Фактический адрес</label>
            <crm-input-text
              [(value)]="contragent.postAddress"
              [isError]="$any(errors?.postAddress)"></crm-input-text>
            <small
              *ngIf="errors?.postAddress"
              class="p-error">
              {{ errors.postAddress | join }}
            </small>
          </div>

          <ng-container *ngIf="contragent.jurisdiction !== JurisdictionTypeEnum.FOREIGN">
            <div class="formgrid grid">
              <div class="field col">
                <label class="font-medium">КПП</label>
                <crm-input-text
                  [(value)]="contragent.kpp"
                  [isError]="$any(errors?.kpp)"></crm-input-text>
                <small
                  *ngIf="errors?.kpp"
                  class="p-error">
                  {{ errors.kpp | join }}
                </small>
              </div>

              <div class="field col">
                <label class="font-medium">ОГРН</label>
                <crm-input-text
                  [(value)]="contragent.ogrn"
                  [isError]="$any(errors?.ogrn)"></crm-input-text>
                <small
                  *ngIf="errors?.ogrn"
                  class="p-error">
                  {{ errors.ogrn | join }}
                </small>
              </div>
            </div>
          </ng-container>
        </div>
      </p-card>
    </div>

    <div class="xl:col-6 lg:col-6 col-12">
      <crm-table-bank-details
        [(bankDetails)]="contragent.bankDetails"
        [jurisdiction]="contragent.jurisdiction"
        [banks]="banks"
        [errors]="$any(errors?.bankDetails)"
        (bankSearch)="searchBank($event)">
      </crm-table-bank-details>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="xl:col-6 lg:col-6 col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveContragent()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete && showDeleteButton"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteContragent()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
